import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
  user: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  userUpdated (state, user) {
    state.user = user;
  }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  increment: ({ commit }) => commit('increment'),
}

// getters are functions
const getters = {
  isLoggedIn: state => state.user != null ? true : false,
  user: state => state.user
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})


//
/*
for documents, store listeners in a hashmap/object when we need them (like unit plans, or unit plan queries) and subscribe to them. store the unsubscribe in the same place. https://firebase.google.com/docs/firestore/query-data/listen

Then when we get updates, commit changes to the store: https://github.com/tcstx/vue-vuex-firebase-tutorial/blob/master/src/store.js



*/


// WEBPACK FOOTER //
// ./src/store/index.js